// Landing v3 — single-purpose sign-up screen (user request, 2026-06). Long-form copy lives at /about.
import React, { useEffect } from "react";

export default function Landing() {
    // Capture ?ref=<username> so the referral survives the OAuth round-trip.
    useEffect(() => {
        const ref = new URLSearchParams(window.location.search).get("ref");
        if (ref) localStorage.setItem("nerdy_ref", ref);
    }, []);

    const signIn = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="signup" data-testid="landing-page">
            <div className="signup-card">
                <div className="wordmark rise" data-testid="landing-wordmark">
                    <span className="bar" />
                    <span>NERDY</span>
                    <span className="caret">_</span>
                </div>
                <h1 className="lh1 signup-h1 rise" style={{ animationDelay: "60ms" }} data-testid="landing-headline">
                    STREAKS YOU<br /><span className="g">CAN'T FAKE.</span>
                </h1>
                <button onClick={signIn} className="btn btn-primary signup-btn rise" style={{ animationDelay: "120ms" }} data-testid="landing-signin-cta">
                    <GoogleMark /> Continue with Google
                </button>
            </div>
        </div>
    );
}

function GoogleMark() {
    return (
        <svg viewBox="0 0 48 48" width="16" height="16" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.7 6c4.5-4.2 6.9-10.3 6.9-17.7z" />
            <path fill="#FBBC05" d="M10.5 28.6A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.1.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z" />
            <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.7-6c-2.1 1.4-4.8 2.3-7.9 2.3-6.3 0-11.6-4.1-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
    );
}
